function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);















/* stuff */

$(document).ready(function() {


// 	// mailchimp
// var $form = $('#mc-embedded-subscribe-form');

// function register($form) {
//   $.ajax({
//     type: $form.attr('method'),
//     url: $form.attr('action').replace('/post?', '/post-json?').concat('&c=?'),
//     data: $form.serialize(),
//     timeout: 5000,
//     cache : false,
//     dataType : 'jsonp',
//     contentType: "application/json; charset=utf-8",
//     error : function(err) { alert("Could not connect to the registration server. Please try again later."); },
//     success : function(data) {
//       if (data.result != "success") {
//         // Something went wrong, do something to notify the user. maybe alert(data.msg); prob need to change this ?
//         alert(data.msg);
//       } else {
//         // It worked, carry on...
//         $form.hide();
//         $('.email_form_success').show();
//       }
//     }
//   });
// };

// // Mailchimp
//   if ( $form.length ) {
//   $form.find('button[type="submit"]').bind('click', function ( event ) {
//     if ( event ) event.preventDefault();
//     register($form);
//   });
// }

/* Are You Ready Document? */

swipey();

collectionSwipey();

$('.toggle').on( 'click', function(event) {

	event.preventDefault();

	$this = $(this);
	
	$thisParent = $(this).parent();

	$thisNext = $(this).next();

	if ($thisParent.hasClass('open')) {

		$thisParent.removeClass('open');
		$thisNext.slideUp(350);

	} else {
		

		$thisParent.siblings('.open').find('.toggle-inner').slideUp(300);
		$thisParent.siblings('.open').removeClass('open').find('.open').removeClass('open');

		$thisParent.addClass('open');
		$thisNext.slideDown(300);

	}

});

$(document).on('resize load hideAnnouncementBar', function() {
	if(!isMobileDevice()){

		$('main').css( 'padding-top', $('header').height());

	}
});

	// nav toggle
	$('.bodyMenu').click( function() {

		$(this).closest('body').toggleClass('menu');
		$(this).closest('header').toggleClass('menu');
	});
	$('.navigation .menu .spy li').click( function() {
        $(this).closest('body').removeClass('menu');
		$(this).closest('header').removeClass('menu');
    });

$('.announcement-bar .close').on('click', function(){
	$(this).parent().hide().trigger('hideAnnouncementBar');
});


	// NEWSLETTER POPUP
	function NewsletterPopupSection(element) {

		var today = new Date();
		var dd = today.getDate();

		var mm = today.getMonth()+1; 
		var yyyy = today.getFullYear();
		if(dd<10) {
			dd='0'+dd;
		} 

		if(mm<10) {
			mm='0'+mm;
		} 

		today = mm+'-'+dd+'-'+yyyy;

		console.log(today);

		var options = JSON.parse(element.getAttribute('data-section-settings'));

		if (!options['showOnlyOnce'] || options['showOnlyOnce'] && today > localStorage.getItem('themePopup') ) {
			setTimeout(function(){

				//do stuff
				openPopup(element);

			}, options['apparitionDelay'] * 1000);
		} else if ($('body').hasClass('template-index')) {
			setTimeout(function(){

				//do stuff
				openPopup(element);

			}, options['apparitionDelay'] * 1000);

		}	
		$(element).find('.PopupClose').on('click', function(event) {
			closePopup(element);
		});

		function openPopup(element) {
			$(element).addClass('is-visible');
			localStorage.themePopup = '';
			localStorage.setItem('themePopup', today );
		}

		function closePopup(element) {
			$(element).removeClass('is-visible');
		}

		function clearThemePopup() {
			localStorage.themePopup = '';
		}

		$('a[href="#popup"]').on('click', function(event) {
			event.preventDefault();

			openPopup(element);
			
		});
	};

	var popup = document.querySelector('.Popup');

	if ($(popup).length) {
		NewsletterPopupSection(popup);

		// mailchimp stuff

		var $form = $('#mc-embedded-subscribe-form');
		
		if ( $form.length ) {
			$form.find('button[type="submit"]').on('click', function ( event ) {
				if ( event ) event.preventDefault();

				//console.log(event);
				register($form);
			});
		}

		function register($form) {
			$.ajax({
				type: $form.attr('method'),
				url: $form.attr('action').replace('/post?', '/post-json?').concat('&c=?'),
				data: $form.serialize(),
				timeout: 5000,
				cache : false,
				dataType : 'jsonp',
				contentType: 'application/json; charset=utf-8',
				error : function(err) { 
					//alert('Could not connect to the registration server. Please try again later.');


					$('.email_form_error').html('Could not connect to the registration server. Please try again later.').show();
				},
				success : function(data) {
					if (data.result != 'success') {

						// Something went wrong, do something to notify the user. maybe alert(data.msg);

						$('.email_form_error').html(data.msg).show();

					} else {
						// It worked, carry on...

						$form.hide();
						$('.email_form_error').hide();
						$('.email_form_success').show();
						$('.Popup__Content').hide();
						/*
						setTimeout(function(){

							//do stuff
							closePopup(popup);

						}, options['apparitionDelay'] * 1000);

						*/
					}
				}
			});
		};
	} // end popup 



	// product add 

	$('form[action="/cart/add"]').submit(function(event) {
		event.preventDefault();
		var addToCartForm = $(this);

		// Disable add to cart button.
		addToCartBtn = addToCartForm.find('button[type="submit"]');

			if($('#SingleOptionSelector-0').find(':selected').prop('disabled')==true){
				$('#SingleOptionSelector-0').addClass('error');
			} else {

					// Add to cart.
					$.ajax({
						url: '/cart/add.js',
						dataType: 'json',
						type: 'post',
						data: addToCartForm.serialize(),
						beforeSend : function (){
							addToCartBtn.find('[data-add-to-cart-text]').html('Adding...');
						},
						success: function(product, cart) {

							$.getJSON('/cart.js', function(cart) {
								$('#cartCount').html(cart.item_count);
							});

							addToCartBtn.find('[data-add-to-cart-text]').html('Add More');

							//$('#product-buttons').hide();
							$('.form-function p').css("display", "inline");
							// $('.form-footer p').show();
						},
						error: function(xhr, status, error) {

							alert(xhr.responseJSON.description);

							//console.log(xhr);

							console.log(xhr.responseJSON.message, ': ', xhr.responseJSON.description);

							addToCartBtn.find('[data-add-to-cart-text]').html('Sold Out');

							addToCartBtn.attr('disabled', true);

						},

					});

			}

	});
	

	$('select').click(function () {
		if ($(this).hasClass('error')){
			$(this).removeClass('error');
		}
	
	});

	// cart	
	$('.qty button').on('click', function() {

		var $button = $(this);
		var oldValue = $button.parent().find('input').val();

		if ($button.text() == '+') {
			var newVal = parseFloat(oldValue) + 1;
		} else {
			// Don't allow decrementing below zero
			if (oldValue > 0) {
				var newVal = parseFloat(oldValue) - 1;
			} else {
				newVal = 0;
			}
		}

		$button.parent().find('input').val(newVal);

		//if in cart
		if ($('body').hasClass('template-cart')) {

				var item = $button.closest('.cart-item'),

				variant_id = item.attr('id'),

				item_total = item.find('.line-item-total'),

				subtotal =  $('.cart-total-price');

				included =  $('.gst-included');

				shipping =  $('#shipping');

				note =  $('#shipping-note');

				$.ajax({
					type: 'POST',
					url: '/cart/change.js',
					dataType: 'json',
					data: {
						quantity: newVal,
						id: variant_id
					},
					success: function(cart) {

						//console.log(cart.total_price);

						if ( newVal == 0 ) {

							item.remove();
						} else {

							$.each(cart.items,function(index,row) {
								if ( variant_id == row.variant_id ) item_total.html( '$' + parseFloat(row.line_price / 100).toFixed(2) );
							});

							$('#cartCount').html(cart.item_count);

						}

						subtotal.html( '$' + parseFloat(cart.total_price / 100).toFixed(2) );

						included.html( '$' + parseFloat(cart.total_price / 1000).toFixed(2) );

						console.log(cart.total_price);
						
						if( cart.total_price >= 18000 ) {

							shipping.html('FREE');

							note.hide();
							
						} else {

							shipping.html('Calculated at checkout');

							note.html('Spend $' + parseFloat(180 - cart.total_price / 100).toFixed(2) + ' more for free shipping').show();

						}

					},
					error: function(xhr, status, error) {

						alert(xhr.responseJSON.description);
						//console.log(xhr);
						console.log(xhr.responseJSON.message, ': ', xhr.responseJSON.description);

					}
				});

		}

	});

if ($('#recent').length ) {

/*	function resizeImage(src, size) {
		if (size == null) {
			return src;
		}

		if (size == 'master') {
			return src.replace(/http(s)?:/, "");
		}

		var match  = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?/i);

		if (match != null) {
			var prefix = src.split(match[0]);
			var suffix = match[0];

			return (prefix[0] + "_" + size + suffix).replace(/http(s)?:/, "")
		} else {
			return null;
		}
	}
*/
	function addItem(product) {

		var link = product['url'];

		var title = product['title'];

		var price = slate.Currency.formatMoney(product['price']);

		var post = '<div class="col-xs-4 col-sm-3 col-md-2"><a class="product-thumb" href="'+ link +'"><div class="prod-img-wrapper"><img id="Image-'+ product['images'][0].id +'" class="lazyload width-100" src="' + slate.Image.getSizedImageUrl(product['images'][0], '300x') + '" data-src="' + slate.Image.getSizedImageUrl(product['images'][0], '1024x') + '" data-aspectratio="1" data-sizes="auto" tabindex="-1" alt=""><img id="Image-'+ product['images'][1].id +'" class="lazyload width-100" src="' + slate.Image.getSizedImageUrl(product['images'][1], '300x') + '" data-src="' + slate.Image.getSizedImageUrl(product['images'][1], '1024x') + '" data-aspectratio="1" data-sizes="auto" tabindex="-1" alt=""></div><p><span class="title">'+ title +'</span><span class="price light hide-xs">'+ price +'</span></p></a>'

		$(post).appendTo('.row.put-items-here');

		if ($('.row.put-items-here').children().length == 0 ) {


			$('#recent').hide();
		}

	}

	function checkHistory() {
		var history = localStorage.history;
		var htmlContent = '';
		var container = document.getElementById('recent');
		var productHandle = $(container).data('product-handle');
		if (history != '' && history != null) {
			var insert = true;
			var products = history.toString().split(',');
			for ( var i = products.length - 1; i >= 0; i--) {
				htmlContent += '<p>'+ products[i] + '</p>';
				if (products[i] == productHandle) {
					insert = false;
				}

				$.ajax({
						dataType: 'json',
						url: '/products/' + products[i] + '.js',
						cache: false,
						success: function(product) {

							//console.log(product);

							addItem(product);

						},
					error: function() {

					}
				});

			}
			if (insert) {

				products.push(productHandle);

				if (products.length === 7) {

					products.shift();
				}

			}
			localStorage.history = products.toString();
		} else {
			var stack = new Array();
			stack.push(productHandle);
			localStorage.history = stack.toString();
		}
	}

	function clearHistory() {
		localStorage.history = '';
		$('#recent .put-items-here').empty();
		console.log('recent cleared');
		checkHistory();
	}

	$('.clear').on('click',function(event){
		event.preventDefault();
		clearHistory();
	});

	checkHistory();

	/*

	*/

}


//modals
function modals() {

	if ($('.blocker').length) {

		$('.blocker').appendTo('body');

		function openModal(modal){

			$('body, .blocker').addClass('modalActive');
			modal.addClass('modalActive zoomIn');

		}

		function closeModal(modal){

			//console.log(modal);
			
			modal.removeClass('zoomIn');
			modal.addClass('zoomOut');
			$('body').removeClass('modalActive');
			modal.one('animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd', function(event) {
				//console.log(event.originalEvent.animationName);
				if (event.originalEvent.animationName == 'zoomOut'){
					modal.removeClass('modalActive zoomOut');
					$('.blocker').removeClass('modalActive');
				}

			});

		}

		$('.modal').each(function(index, element) {

			var $this = $(this);

			//console.log($this);

			$('[data-open-modal="'+ $this.attr('id') + '"]').on('click', function() {
				
				openModal($this);

			});

			$('.blocker').on('click', function(event) {

				//console.log(event.target);

				if (event.target.className == 'blocker modalActive' ) {

					closeModal($('.modal.modalActive'));
				}

			});
			$('.close').on('click', function(event) {

				closeModal($('.modal.modalActive'));

			});
		});

		$(document).on( 'keydown', function(event){

			//console.log(event.key);

			if(event.key == 'Escape') {
					if($('.modal.modalActive').length){
						closeModal($('.modal.modalActive'));
					}
			}

		});

	}

}

modals();


// related (Recommended)

var list = document.querySelector('.product-recommendations');

if ($(list).length) {

	var productId = list.dataset.productId;

	console.log(productId);

	var request = new XMLHttpRequest();

	request.open(
		'GET',
		'/recommendations/products.json?product_id=' + productId + '&limit=4'
	);

	request.onload = function() {

		if (request.status === 404 || request.status === 422) {
			return hideRecommendationsSection();
		}

		var products = JSON.parse(request.response).products;

		if (products.length === 0) {
			return hideRecommendationsSection();
		}

		list.querySelector('.grid').innerHTML = products.map(function(product) { 

			//console.log(product.id);

			if (product.images[0].length && product.images[1].length) {

				return renderProduct(product);

			}
			
			
		}).join('');
	};

	request.onerror = function() {
		hideRecommendationsSection();
	};

	request.send();

	function hideRecommendationsSection() {
		list.style.display = 'none';
	}

	function renderProduct(product, data) {

		return [
			'<div class="col-xs-6 col-sm-3">',
			'<a class="product-thumb" href="' + product.url + '">',
			'<div class="prod-img-wrapper">',
			'<img id="Image-'+ product.images[0].id +'" class="lazyload width-100" src="' + slate.Image.getSizedImageUrl(product.images[0], '300x') + '" data-src="' + slate.Image.getSizedImageUrl(product.images[0], '1024x') + '" data-aspectratio="1" data-sizes="auto" tabindex="-1" alt="">',
			//'<img src="' + slate.Image.getSizedImageUrl(product.images[0], '640x') + '" alt="'+ product.title +'"/>',
			'<img id="Image-'+ product.images[1].id +'" class="lazyload width-100" src="' + slate.Image.getSizedImageUrl(product.images[1], '300x') + '" data-src="' + slate.Image.getSizedImageUrl(product.images[1], '1024x') + '" data-aspectratio="1" data-sizes="auto" tabindex="-1" alt="">',
			//'<img src="' + slate.Image.getSizedImageUrl(product.images[1], '640x') + '" alt="'+ product.title +'"/>',
			'</div>',
			'<p>',
			'<span class="title">' + product.title + '</span>',
			'<span class="price light">' + slate.Currency.formatMoney(product.price) + '</span>',
			'</p>',
			'</a>',
			'</div>'
		].join('');
	}

}


function scrollReveal() {

// ScrollMagic
	var controller = new ScrollMagic.Controller();

	$('.rev').each(function() {
		
		tween70 = TweenMax.staggerFromTo($(this), 0.25, {
				opacity: 0,
				scale: 0.95,
				y: '+=5',
				ease:Linear.easeNone
			},
			{
				opacity: 1,
				scale: 1,
				y: '0',
				ease:Linear.easeNone
			},
			0.4 //stagger offset duration ?? 
		);

		new ScrollMagic.Scene({
			triggerElement: this,
			triggerHook: 0.98,
			reverse: true,
			offset: 50
		})

		.setTween(tween70) 
		.addTo(controller);

	});

	$('.slomo').each(function() {

		var tween69 = TweenMax.staggerFromTo($(this), 0.75, {
				opacity: 0,
				y: '+=60',
			},
			{
				opacity: 1,
				y: '0',
			},
		);

		new ScrollMagic.Scene({
			triggerElement: this,
			triggerHook: 1,
			reverse: true,
			offset: 50
			
		})

		.setTween(tween69) 
		.addTo(controller);

	});

};

scrollReveal();

function doParallax() {

	var controller = new ScrollMagic.Controller();

	$('.p-row-x').each(function(index) {
		
		var image = $(this).find('.p-col-x')[0];
	
		var parallaxxx = new TimelineMax();

		parallaxxx.fromTo(image, 1, {
			y: '-50%'
		},
		{
			y: '50%'
		});

		var scene = new ScrollMagic.Scene({
			triggerElement: this,
			duration: '200%',
			triggerHook: 1
		})
		.setTween(parallaxxx)
		.addTo(controller); 
	});

	$('.p-row').each(function(index) {
		
		var image = $(this).find('.p-col')[0];
	
		var parallax = new TimelineMax();

		parallax.fromTo(image, 1, {
			y: '-50%'
		},
		{
			y: '16.66%'
		});

		var scene = new ScrollMagic.Scene({
			triggerElement: this,
			duration: '200%',
			triggerHook: 1
		})
		.setTween(parallax)
		.addTo(controller); 
	});

}

doParallax();


function drinkWine() {

	var controller = new ScrollMagic.Controller();

	$('.wine-bar').each(function(index) {
		
		var image = $(this).find('.wine-bottle')[0];
	
		var parallax = new TimelineMax();

		parallax.fromTo(image, 1, {
			y: '-11%'
		},
		{
			y: '6.66%'
		});

		var scene = new ScrollMagic.Scene({
			triggerElement: this,
			duration: '200%',
			triggerHook: 1
		})
		.setTween(parallax)
		.addTo(controller); 
	});

}
drinkWine();


function doTime() {

	var controller = new ScrollMagic.Controller();

	$('.prison').each(function(index) {
		
		var image = $(this).find('.prisoner')[0];
	
		var parallax = new TimelineMax();

		parallax.fromTo(image, 1, {
			y: '-80%'
		},
		{
			y: '26.66%'
		});

		var scene = new ScrollMagic.Scene({
			triggerElement: this,
			duration: '200%',
			triggerHook: 1
		})
		.setTween(parallax)
		.addTo(controller); 
	});

}
doTime();

function horizontalTango() {

	var controller = new ScrollMagic.Controller();

	$('.harry').each(function(index) {
		
		var image = $(this).find('.sally')[0];
	
		var parallax = new TimelineMax();

		parallax.fromTo(image, 1, {
			x: '-196%'
		},
		{
			x: '66%'
		});

		var scene = new ScrollMagic.Scene({
			triggerElement: this,
			duration: '200%',
			triggerHook: 80
		})
		.setTween(parallax)
		.addTo(controller); 
	});

}

horizontalTango();


function smoothScroll() {

		$('a[href*="#"]').click(function() {
			if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
				var target = $(this.hash);
				target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
				if (target.length) {

					var targetOffset = target.offset().top - 50;

					$('html, body').animate({
						scrollTop: targetOffset 
					}, 1133);
					

					
        $(this).closest('body').removeClass('menu');
		$(this).closest('header').removeClass('menu');




				}
			}
		});

	}

smoothScroll();

fadeIn();

});// end document ready

function fadeIn() {


	$('img').each(function() {

		var $this = $(this);

		imagesLoaded( $this, { background: true }, function() {
		//$(window).on( 'load', function() {

			TweenMax.to( $this, .3, {
				opacity: 1, 
				ease: Linear.easeIn,
			});

		});
	});
}


newSwipers = [];

function swipey() {

	$('.slideshow:not(.collection)').each(function(index, element) {
		var $this = $(this);

		$this.addClass('s'+index);

		var parameters = {
			preventClicks: true,
			speed: 444,
			spaceBetween: 0,
			mousewheel: false,
			observer: true,
			slidesPerView: 1,
            autoplay: {
              delay: 3000,
            },
			//observeParents: true,
			pagination: {
				el: $this.parent().find('.swiper-pagination')[0],
				clickable: true
			},
			navigation: {
				nextEl: $this.parent().find('.next')[0],
				prevEl: $this.parent().find('.prev')[0]
			},
			keyboard: {
				enabled: true,
				onlyInViewport: false,
			}
		};

		parameters.on = {
			slideChange: function (swiper) {
			},
		};

		if($this.hasClass('fade')) {
			parameters.effect = 'fade';
			parameters.speed = 333;
			parameters.fadeEffect = {crossFade: true};
			parameters.loop = true;
			parameters.autoHeight = true;
			parameters.autoplay = { delay: 5000 };
		
		} else if(isMobileDevice()){

			parameters.freeMode = true;
		}

		if($this.hasClass('announcement-bar')) {
			parameters.pagination = false;
			parameters.navigation = false;
			parameters.keyboard = false;
			parameters.effect = 'fade';
			parameters.speed = 333;
			parameters.fadeEffect = {crossFade: true};
			parameters.loop = true;
			parameters.autoHeight = true;
			parameters.autoplay = { delay: 2500 };
		}

		// if($this.hasClass('collection')) {

		// 	parameters.centeredSlides = true;
		// 	parameters.slidesPerView = 3;
		// 	parameters.spaceBetween = convertRemToPixels(1);
		// 	parameters.breakpoints = {
		
		// 		640: {
		// 			slidesPerView: 1,
		// 			slidesPerGroup: 1,
		// 		},
		// 		768: {
		// 			slidesPerView: 3,
		// 			slidesPerGroup: 3,
		// 		}
				
		// 	};
		//   	parameters.navigation = {
		// 		nextEl: $this.parent().find('.btn-next')[0],
		// 		prevEl: $this.parent().find('.btn-prev')[0]
		// 	};
		// 	//parameters.autoplay = { delay: 5000 }; 
		// }

		if($this.find('.swiper-slide').length > 1) {

			//this is where the slider is initialized 
			var newSwiper = new Swiper($this, parameters );

			newSwipers.push(newSwiper);

			if($this.hasClass('fade')) {
				//pause swiper if not in viewport
				$(window).on('resize scroll', function() {

					if ($this.isInViewport()) {
						newSwiper.autoplay.start();
						//console.log(newSwiper, 'autoplay start');
					} else {
						newSwiper.autoplay.stop();
						//console.log(newSwiper, 'autoplay stop');
					}

				});
			}
		}

		//newSwiper.autoplay.start(); 
		//newSwiper.autoplay.stop();

		// $this.on('mouseenter mouseleave', function(event) {

		// 	if (event.type == 'mouseenter') {
				
		// 		newSwiper.autoplay.start();

		// 	} else {

		// 		newSwiper.autoplay.stop();
		// 	}


		// });





	});

}


function collectionSwipey() {

	if($('.slideshow.collection').length > 0) {

		var mobileSwiper = '';

		var breakpoint = window.matchMedia( '(min-width:768px)' );

		var toggleSlider = function() {

			if ( breakpoint.matches === true ) {
				//console.log('does');
				
				//disable mobile swiper
				if ( mobileSwiper != '' ) {
					mobileSwiper.destroy( true, true );
					mobileSwiper = '';
					toggleClasses();
				}
				
			} else if ( breakpoint.matches === false ) {
				//console.log('does not');

				//enable 
				enableMobile();
			}
		};

		var toggleClasses = function () {
			$('.slideshow.collection').toggleClass('swiper-container');
			$('.slideshow.collection > div ').toggleClass('swiper-wrapper row');
			$('.slideshow.collection > div > div ').toggleClass('swiper-slide col-'+$('.slideshow.collection > div > div ').attr('data-size'));
		};

		var enableMobile = function() {
			
			toggleClasses();
			
			mobileSwiper = new Swiper('.slideshow.collection', {
				autoHeight: true,
                slidesPerView: $('.slideshow.collection > div > div ').attr('data-mob-size'),
				pagination: {
					el: $('.slideshow.collection').parent().find('.swiper-pagination')[0],
					clickable: false,
					type: 'fraction',
				},
				keyboard: {
					enabled: true,
					onlyInViewport: false,
				},
				navigation: {
					nextEl: '.next',
					prevEl: '.prev',
				}
			});

		};


		toggleClasses();

		breakpoint.addListener(toggleSlider);
		toggleSlider();


	};


};



function isMobileDevice() {
	return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
};

function convertRemToPixels(rem) {    
	return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
}
// // focus search field on mouse over
// var inputField = document.getElementById('Search');

// inputField.addEventListener('mouseover', function() {
//     inputField.focus();
// });


(function () {
// Integration with the theme editor

	document.addEventListener('shopify:section:load', function (event) {

		//console.log('shopify:section:load : ', event);

		section = document.getElementById('shopify-section-' + event.detail.sectionId);
		
		if ($(section).find('.swiper-container').length){

			let swiper = $(section).find('.swiper-container')[0].swiper;
			
			if (swiper != undefined) {
				console.log(swiper);

				swiper.init();

				swiper.update();
			}
		
		}
		if($('.slomo , .rev').length){
			$('.slomo , .rev').css({
				'opacity': 1
			});
		}


	});

	document.addEventListener('shopify:section:unload', function (event) {
		
		//console.log('shopify:section:unload : ', event);

	});

	document.addEventListener('shopify:section:select', function (event) {
		
		//console.log('shopify:section:select : ', event);

	});

	document.addEventListener('shopify:section:deselect', function (event) {
		
		//console.log('shopify:section:deselect : ', event);

	});

	document.addEventListener('shopify:section:reorder', function (event) {
/*		
		console.log('shopify:section:reorder : ', event);

		section = document.getElementById('shopify-section-' + event.detail.sectionId);

		//console.log(section);
		swiper = $(section).find('.swiper-container')[0].swiper;

		if (swiper != undefined) {
			console.log(swiper);

			swiper.update();
		}
*/
	});

	document.addEventListener('shopify:block:select', function (event) {

		//console.log('shopify:block:select : ', event );

		//console.log(event.detail.sectionId);

		section = document.getElementById('shopify-section-' + event.detail.sectionId);

		if ($(section).find('.swiper-container').length){

			//console.log(section);

			let swiper = $(section).find('.swiper-container')[0].swiper;

			if (swiper != undefined) {

				//console.log(swiper);
				
				//swiper = $(section).find('.swiper-container').swiper;

				//console.log(swiper);

				//console.log('block index : ', $(event.target).index());

				//console.log('swiper index : ', swiper.activeIndex);

				//mySwiper.slideTo(index, speed, runCallbacks);

				swiper.slideTo($(event.target).index(), 300);

				swiper.update();

				//console.log(swiper);

			}
		}

		if($('.slomo , .rev').length){
			$('.slomo , .rev').css({
				'opacity': 1
			});
		}
			
	});

	document.addEventListener('shopify:block:deselect', function (event) {

		//console.log('shopify:block:deselect : ', event);

		//console.log('shopify:block:deselect : ', event);
		if ($(section).find('.swiper-container').length){

				//console.log(section);

				let swiper = $(section).find('.swiper-container')[0].swiper;

				if (swiper != undefined) {
				//console.log(swiper);

				swiper.update();
			}
		}

	});

})();
